import { useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';

import { NavIconVariants } from '../../ui/icons/types';

export default function useNavIconVariants() {
  const { darkTheme } = useTheme();

  const defaultColor = useMemo(
    () => (darkTheme ? '#FFFFFFB8' : '#18192B'),
    [darkTheme]
  );

  const activeColor = useMemo(
    () => (darkTheme ? '#FFFFFF' : '#234DFF'),
    [darkTheme]
  );

  const strokeOpacityActive = useMemo(() => (darkTheme ? 1 : 0.4), [darkTheme]);

  const strokeOpacityInactive = useMemo(
    () => (darkTheme ? 0.4 : 1),
    [darkTheme]
  );

  return {
    default: {
      fill: 'none',
      stroke: defaultColor,
      fillOpacity: 0.08,
      strokeOpacity: strokeOpacityInactive,
    },
    active: {
      fill: activeColor,
      stroke: activeColor,
      fillOpacity: 0.08,
      strokeOpacity: strokeOpacityActive,
    },
  } as NavIconVariants;
}
